









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IPantallaVm } from './fetchPantallaVm';

@Component({
  components: {},
})
export default class CardInformativa extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: () => ({ titulo: 'hola', mensaje: 'algo' }) })
  elemento!: IPantallaVm[];

  map: google.maps.Map;
  elementosShow: any;
  infoWindow = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: true,
  });
  locations: any = [];
  labels: any = [];

  @Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.elementosShow = this.elemento;
    console.log(this.elementosShow);
  }
  mounted() {}
}
